import axios from 'axios'
import MockAdapter from 'axios-mock-adapter'

let spoofingAdapter;

const requests = {
  delete: [],
  put: [],
  patch: []
}

/**
 * add request to list ready to be spoofed later when enabling spoofing with enableMethodSpoofing()
 * 
 * @param {string} method lowercase method name
 * @param {string|Regex} path request path string or regex
 */
export function addRequest(method, path) {
  if (method in requests) {
    requests[method].push(path);
  }
}

/**
 * enable method spoofing for given methods, MUST be called after all mock registrations
 * 
 * @param {Array<string>} methods methods to enable spoofing for
 */
export function enableMethodSpoofing(methods) {
  spoofingAdapter = new MockAdapter(axios);

  methods.forEach(method => {
    method = method.toLowerCase();

    if (method in requests) {
      requests[method].forEach(path => {
        spoofRequest(method, path);
      });

    } else {
      throw `[api-mock / method-spoofing] invalid method name (${method}).`
    }
  });

  spoofingAdapter.onAny().passThrough();
}

/**
 * register request for spoofing
 * 
 * @param {string} method lowercase method name
 * @param {string|Regex} path request path string or regex
 */
function spoofRequest(method, path) {
  const _this = spoofingAdapter;
  const [foundIndex, foundCallback] = findHandler(path);

  const callback = (config) => {
    const data = (config.data && JSON.parse(config.data)) || {};

    if (data._method && data._method.toLowerCase() === method) {
      delete data._method;
      const newConfig = {
        ...config,
        method,
        data: JSON.stringify(data),
      }
      // pass through updated request with real method
      return _this.originalAdapter(newConfig);
    } else {
      if (foundCallback) {
        // pass through to original callback (if any)
        return foundCallback(config);
      } else {
        // pass through original request
        return _this.originalAdapter(config);
      }
    }
  }

  if (foundCallback) {
    _this.handlers.post[foundIndex][3] = callback;
  } else {
    _this.onPost(path).reply(config => {
      return callback(config);
    });
  }
}

function findHandler(matcher) {
  let found = [-1, undefined];
  spoofingAdapter.handlers.post.forEach((handler, index) => {
    if (handler.length == 6 && handler[0].toString() === matcher.toString()) {
      found = [index, handler[3]];
    }
  });
  return found;
}
